import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import masterRoutes from '@/router/routes/master.js'
import sidasiRoutes from '@/router/routes/sidasi.js'

export default allRoutes.concat(
  publicRoutes,
  privateRoutes,
  masterRoutes,
  sidasiRoutes
)